/**
 * isX5
 * @author marvinqi
 * @createTime 2017/9/20
 */
import getUA from './getUA'
import isAndroid from './isAndroid'
export default function () {
  return isAndroid() && /\s(TBS|X5Core)\/[\w\.\-]+/i.test(getUA())
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isX5.js